RivalIQ.module('export.data', function (data, App, Backbone, Marionette, $, _) {

    'use strict';

    data.filetypes = new Backbone.Collection([
        {
            id: RivalIQ.export.enums.filetypes.IMAGE,
            name: 'PNG',
            icon: 'fa-file-image-o'
        },
        {
            id: RivalIQ.export.enums.filetypes.REPORT,
            name: 'PPT',
            icon: 'fa-file-o fa-file-ppt'
        },
        {
            id: RivalIQ.export.enums.filetypes.PDF,
            name: 'PDF',
            icon: 'fa-file-o fa-file-pdf'
        },
        {
            id: RivalIQ.export.enums.filetypes.CSV,
            name: 'CSV',
            icon: 'fa-file-o fa-file-csv'
        }
    ]);
});
